export default __webpack_public_path__ + "static/media/api.66e2ccd0.svg";